import { useQuery } from "@apollo/client";
import { FeaturedCard, Query } from "@onmo/graphql/graphql";
import { meGQL } from "../graphql";
import { resolveServiceId, getImages } from "../constants/services";
import { useFeaturedCards } from "./useFeaturedCards";
import { useMemo } from "react";
import { useProductByTenants } from "./useProductByTenants";
import { useTgpSubscriptions } from "./useTgpSubscriptions";
import { useAppSelector } from "../components/hooks";

// Types
interface ServiceItem {
  id: string;
  title: string;
  icon: string;
  link: string;
}


export function useDirectoryData() {
  const { data: dataMe } = useQuery<Query>(meGQL);
  const { products, getProductIcon } = useProductByTenants();
  const { homeFeed } = useFeaturedCards();
  const { theme } = useAppSelector((state) => state.theme);
  const subEnabled = theme?.pages?.directory?.includes("mySubscriptions");
  const { subscriptions: subscriptionData } = useTgpSubscriptions(subEnabled);

  const subscriptions = useMemo((): ServiceItem[] => {
    return (subscriptionData ?? [])
      .map((sub) => {
        const productId = sub.product?.id ?? sub.productId;
        const id = resolveServiceId(productId);
        const link = products.find(
          (product) => product.id === productId,
        )?.appUrl;
        if (!id || !link) return null;

        return {
          id,
          title: sub.product?.title ?? id,
          icon: sub.product?.icon ?? getProductIcon(id) ?? "",
          link,
        };
      })
      .filter((item): item is ServiceItem => item !== null);
  }, [products, subscriptionData, getProductIcon]);

  const favoriteItems = dataMe?.me?.metadata?.tgpFavoriteItems ?? [];
  const recentlyPlayedItems = dataMe?.me?.metadata?.tgpRecentlyPlayed ?? [];

  const listService = useMemo((): ServiceItem[] => {
    if (!products.length) {
      return [];
    }

    return products.map((product) => {
      return {
        id: product.id,
        title: product.productBranding?.title ?? product.id,
        icon: product.productBranding?.icon ?? getImages(product.id),
        link: product.appUrl,
      };
    });
  }, [homeFeed, products]);
  const allGames: FeaturedCard[] = useMemo(() => {
    if (!homeFeed?.length) return [];
    return homeFeed.filter((entry): entry is FeaturedCard => entry !== null);
  }, [homeFeed]);

  return {
    favouriteGames: favoriteItems,
    recentlyPlayed: recentlyPlayedItems,
    listService,
    subscriptions,
    allGames,
  };
}
